const dayMs = 86400000;
const isoDay = date => date.toISOString().slice(0, 10);
const addDay = date => new Date(date.getTime() + dayMs);
const easterDates = new Map();

function easter(year) {
  const a = year % 4, b = year % 7, c = year % 19;
  const d = (19 * c + 15) % 30;
  const e = (2 * a + 4 * b - d + 34) % 7;
  const month = Math.floor((d + e + 114) / 31);
  const day = (d + e + 114) % 31 + 1;
  return new Date(Date.UTC(year, month - 1, day + 13, 12));
}

export function businessDay(date) {
  if (date.getUTCDay() === 0 || date.getUTCDay() === 6) return false;
  const year = date.getUTCFullYear();
  if (!easterDates.has(year)) {
    const sunday = easter(year);
    const dates = new Set(['01-01', '01-02', '01-06', '01-07', '01-24', '05-01', '06-01', '08-15', '11-30', '12-01', '12-25', '12-26'].map(day => year + '-' + day));
    for (const offset of [-2, 0, 1, 49, 50]) dates.add(isoDay(new Date(sunday.getTime() + offset * dayMs)));
    easterDates.set(year, dates);
  }
  return !easterDates.get(year).has(isoDay(date));
}

function nextBusinessDay(date) {
  let next = addDay(date);
  while (!businessDay(next)) next = addDay(next);
  return next;
}

export function deliveryWindow(now, cutoffHour = 14) {
  if (!(now instanceof Date) || !Number.isFinite(now.getTime()) || !Number.isInteger(cutoffHour) || cutoffHour < 0 || cutoffHour > 23) return null;
  const parts = new Intl.DateTimeFormat('en-GB', {timeZone: 'Europe/Bucharest', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23'}).formatToParts(now);
  const values = Object.fromEntries(parts.map(part => [part.type, part.value]));
  const year = Number(values.year);
  if (year < 2026 || year > 2099) return null;
  const today = new Date(Date.UTC(year, Number(values.month) - 1, Number(values.day), 12));
  const dispatch = businessDay(today) && Number(values.hour) < cutoffHour ? today : nextBusinessDay(today);
  const start = nextBusinessDay(dispatch), end = nextBusinessDay(start);
  return {dispatch, start, end};
}

export function selectionReturnURL(record, handle, origin, now = Date.now()) {
  if (!record || record.handle !== handle || !Number.isFinite(record.at) || now - record.at < 0 || now - record.at > 1200000 || typeof record.url !== 'string') return null;
  try {
    const url = new URL(record.url, origin);
    if (url.origin !== origin || !/^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?collections\/[^/]+\/?$/.test(url.pathname)) return null;
    return url.href;
  } catch { return null; }
}

function restoreSelection() {
  document.querySelectorAll('[data-iu-return-selection]').forEach(link => {
    let destination = null, newest = -1;
    try {
      for (let index = 0; index < sessionStorage.length; index++) {
        const key = sessionStorage.key(index);
        if (!key?.startsWith('iu-catalog-return-v144:')) continue;
        let record;
        try { record = JSON.parse(sessionStorage.getItem(key)); } catch { continue; }
        const url = selectionReturnURL(record, link.dataset.productHandle, location.origin);
        if (url && record.at > newest) { destination = url; newest = record.at; }
      }
    } catch {}
    if (!destination && document.referrer) {
      const record = {url: document.referrer, handle: link.dataset.productHandle, at: Date.now()};
      destination = selectionReturnURL(record, link.dataset.productHandle, location.origin);
    }
    if (!destination) return;
    link.href = destination;
    link.querySelector('[data-iu-return-label]').textContent = link.dataset.returnLabel;
  });
}

function updateDelivery() {
  const now = new Date();
  const locale = document.documentElement.lang || 'ro';
  const formatter = new Intl.DateTimeFormat(locale, {timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'short'});
  document.querySelectorAll('[data-iu-delivery-estimate]').forEach(element => {
    const range = deliveryWindow(now, Number(element.dataset.cutoffHour));
    if (!range) return;
    const text = element.dataset.deliveryPattern.replace('[start]', formatter.format(range.start).replaceAll(' ', '\u00a0')).replace('[end]', formatter.format(range.end).replaceAll(' ', '\u00a0'));
    if (element.textContent !== text) element.textContent = text;
  });
}

// Keep the activated chapter in place when the sticky desktop column grows.
// Native <details> still handles opening, closing and keyboard activation.
function preserveChapterPosition(event) {
  if (event.button !== 0 || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
  const summary = event.target instanceof Element && event.target.closest('.iu-product-information .iu-choice-guide__chapter > summary');
  if (!summary || event.target.closest('a, button, input, select, textarea')) return;
  const top = summary.getBoundingClientRect().top;
  if (top < 0 || top >= innerHeight) return;
  let cancelled = false;
  const cancel = () => { cancelled = true; };
  const options = {passive: true, once: true};
  for (const type of ['wheel', 'touchmove', 'keydown']) window.addEventListener(type, cancel, options);
  let frames = 2;
  const settle = () => {
    if (!cancelled && summary.isConnected) {
      const delta = summary.getBoundingClientRect().top - top;
      if (Math.abs(delta) > 0.5) window.scrollBy({top: delta, behavior: 'instant'});
    }
    if (--frames > 0) requestAnimationFrame(settle);
    else for (const type of ['wheel', 'touchmove', 'keydown']) window.removeEventListener(type, cancel);
  };
  requestAnimationFrame(settle);
}

if (typeof document !== 'undefined') {
  document.addEventListener('click', preserveChapterPosition, true);
  restoreSelection();
  updateDelivery();
  addEventListener('pageshow', () => { restoreSelection(); updateDelivery(); });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) updateDelivery(); });
  setInterval(() => { if (!document.hidden) updateDelivery(); }, 60000);
}
